import { MapPin, CalendarDays, Scale, Lightbulb } from "lucide-react";

const H = { fontFamily: "Quicksand, sans-serif" };

const Block = ({ icon: Icon, title, children, testid }) => (
  <div className="surface-card p-6 md:p-7" data-testid={testid}>
    <div className="flex items-center gap-3">
      <span className="w-10 h-10 rounded-full bg-accent/10 text-accent flex items-center justify-center shrink-0"><Icon size={18} /></span>
      <h3 className="font-bold text-lg md:text-xl" style={H}>{title}</h3>
    </div>
    <div className="mt-4 text-muted-foreground leading-relaxed">{children}</div>
  </div>
);

export default function CityLocalGuide({ city }) {
  const l = city.local;
  if (!l) return null;
  return (
    <section className="py-14 md:py-20" data-testid="city-local-guide">
      <div className="container-tm">
        <span className="pill">Guide local · {city.name}</span>
        <h2 className="h-section mt-4 max-w-3xl">Louer en courte durée à {city.name} : ce qu'il faut savoir</h2>
        <div className="mt-10 grid lg:grid-cols-2 gap-5">
          <Block icon={MapPin} title={`Les quartiers qui louent le mieux à ${city.name}`} testid="city-local-quartiers">
            <ul className="space-y-3">
              {l.quartiers.map((q) => (
                <li key={q.name}><span className="font-semibold text-foreground">{q.name}</span> : {q.why}</li>
              ))}
            </ul>
          </Block>
          <Block icon={CalendarDays} title={`La vraie saisonnalité à ${city.name}`} testid="city-local-saison"><p>{l.saison}</p></Block>
          <Block icon={Scale} title={`Réglementation à ${city.name} en 2026`} testid="city-local-reglementation"><p>{l.reglementation}</p></Block>
          <Block icon={Lightbulb} title="Notre conseil de propriétaire" testid="city-local-conseil"><p>{l.conseil}</p></Block>
        </div>
      </div>
    </section>
  );
}
